import { render, staticRenderFns } from "./BadgeExpirationWarning.vue?vue&type=template&id=805f5ffa&scoped=true"
import script from "./BadgeExpirationWarning.vue?vue&type=script&lang=js"
export * from "./BadgeExpirationWarning.vue?vue&type=script&lang=js"
import style0 from "./BadgeExpirationWarning.vue?vue&type=style&index=0&id=805f5ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805f5ffa",
  null
  
)

export default component.exports